import { transparentize } from 'polished';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  max-width: 1312px;
  height: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-left: 24px;
  padding-right: 24px;

  display: flex;
  justify-content: space-between;

  @media (max-width: 768px) {
    padding-left: 1rem;
    padding-right: 0px;

    button.MuiButtonBase-root {
      z-index: 999999;
      border-radius: 50%;
      height: 62px;
      width: 62px;
      margin-top: -21px;

      &.active {
        position: fixed;
        right: 0;
        top: 2.32rem;
      }
    }
  }
`;

export const Backdrop = styled.div`
  display: none;

  @media (max-width: 768px) {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    z-index: 9;
    position: fixed;
    align-items: center;
    justify-content: center;
    background-color: rgba(242, 243, 245, 0.8);
    -webkit-tap-highlight-color: transparent;
    transition: 400ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    visibility: hidden;
    opacity: 0;

    &.active {
      visibility: visible;
      opacity: 1;
    }
  }
`;

export const MenuMobile = styled.div`
  @media (min-width: 769px) {
    position: absolute;
    right: 0px;
    top: calc(100% + 12px);
    width: 256px;
    padding: 0px;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.1);
    transition: 400ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    opacity: 0;
    visibility: hidden;
    z-index: 99999;

    &.active {
      opacity: 1;
      visibility: visible;
    }

    li {
      padding: 0px !important;
    }

    &:before {
      content: '';
      position: absolute;
      top: -8px;
      right: 19px;
      width: 0px;
      height: 0px;
      border-style: solid;
      border-width: 0px 8px 8px;
      border-color: transparent transparent #ccc;
    }

    div:first-child() {
      padding-top: 16px;
    }

    div {
      width: 100%;

      svg {
        margin-right: 1rem;
      }

      a {
        display: flex;
        align-items: center;
        font-size: 16px;
        color: ${props => props.theme.textColor};
        padding: 0.8rem 1rem;
        transition: background 0.2s ease 0s;
        cursor: pointer;
        background: transparent;
        border: none;
        width: 100%;

        &:first-child() {
          padding-top: 16px;
        }
      }
    }
  }

  @media (max-width: 768px) {
    background: #fff;
    box-shadow: 0 0 60px rgba(0, 0, 0, 0.05);
    border-left: 1px solid #e6e6e6;
    position: fixed;
    top: 0;
    right: -100%;
    bottom: 0;
    width: 80%;
    z-index: 99999;
    opacity: 0;
    visibility: hidden;
    transition: 400ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

    li {
      color: #166649;
      transition: 0.3s ease-in-out;
      border-left: 4px solid #fff;
      height: 4rem;

      &:hover {
        background: ${transparentize(0.8, '#166649')};
        border-left-color: #166649;
      }

      &:hover a {
        color: #166649;
      }
    }

    li div {
      width: 100%;

      a {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: ${props => props.theme.textColor};

        svg {
          margin-right: 1rem;
        }
      }
    }

    &.active {
      right: -1px;
      opacity: 1;
      visibility: visible;
      border-top-left-radius: 25px;
      border-bottom-left-radius: 25px;
    }
  }
`;

export const UserContainerMobile = styled.header`
  display: none;

  @media (max-width: 768px) {
    width: 75%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 1.8rem 0rem;
    pointer-events: none;
    user-select: none;
    margin-left: 1.3rem;
    border-bottom: 1px solid #ececec;

    img {
      margin-right: 1rem;
    }
  }
`;

export const HeaderPage = styled.header`
  border-top: 5px solid ${props => props.theme.secondaryColor};
  border-bottom: 1px solid ${props => props.theme.onBackground};
  background: ${props => props.theme.background};
  padding: 2rem 0rem;

  figure {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 5px;

    a img {
      width: 180px;
    }
  }

  @media (max-width: 768px) {
    /* padding: 1.5rem 0rem; */
    height: 90px;

    figure a img {
      width: 130px;
    }
  }
`;

export const UserContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: transparent;
  border: 0;
  pointer-events: none;

  > img {
    margin-right: 10px;
    width: 33px;
    height: 33px;
    object-fit: cover;
    border-radius: 50%;
  }

  > span {
    transition: color 0.3s ease-out;
    color: ${props => props.theme.textColor};
    pointer-events: none;
    text-transform: capitalize;
    font-weight: 400;
    font-size: 12px;
  }

  @media (max-width: 768px) {
    display: none;

    > img {
      margin-right: 10px;
      width: 30px;
      height: 30px;
    }
  }
`;

export const Hamburger = styled.label`
  pointer-events: none;
  display: none;

  span {
    width: 25px;
    height: 3px;
    background: ${props => props.theme.secondaryColor};
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -12.5px;
    margin-top: -1.5px;
    transition: transform 200ms;
    z-index: 99999;
  }

  .hamburger-1 {
    transform: translate3d(0, -8px, 0);
  }

  .hamburger-2 {
    transform: translate3d(0, 0, 0);
  }

  .hamburger-3 {
    transform: translate3d(0, 8px, 0);
  }

  .hamburger-1.active {
    transform: translate3d(0, 0, 0) rotate(45deg);
  }
  .hamburger-2.active {
    transform: translate3d(0, 0, 0) scale(0.1, 1);
  }
  .hamburger-3.active {
    transform: translate3d(0, 0, 0) rotate(-45deg);
  }

  @media (max-width: 768px) {
    display: block;
  }
`;
